import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLayoutLeft"><Path d="M7.75 6.75C7.75 5.09315 9.09315 3.75 10.75 3.75L17.25 3.75C18.9069 3.75 20.25 5.09315 20.25 6.75L20.25 17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H10.75C9.09315 20.25 7.75 18.9069 7.75 17.25L7.75 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M3.75 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLayoutLeft;
